import { useCallback, useState } from "react";
// Relative: a pure module, resolvable under Jest without a shim.
import useAdminLoad from "../hooks/useAdminLoad";
import { listTenantRedemptions } from "./api";

/**
 * The current practice's platform-code redemptions (contract §5.5), newest first.
 *
 * A failed read is its own state (`loadError`), never an empty list: "no codes redeemed"
 * said to a practitioner whose gift card WAS spent is the kind of false claim that sends
 * them to support, or to redeem it again.
 *
 * @returns {{items: object[], loading: boolean, loadError: any, reload: () => Promise<void>}}
 */
export default function useTenantRedemptions() {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    const data = await listTenantRedemptions();
    setItems(data.items);
  }, []);
  const { loading, loadError, reload } = useAdminLoad(load);
  return { items, loading, loadError, reload };
}
